<template>

  <form id="addSessionForm" @submit.prevent="submitForm">
    <div class="steps-w" v-if="filteredSteps.length > 0">
      <div class="step-triggers">
        <a :class="{ 'active': step.key == currentStep.key, 'step-trigger': 1==1}" v-for="step in filteredSteps" @click="customStep(step.key)">{{step.name}}</a>
      </div>
      <div class="step-contents">

        <PhotodeskSteps :currentStep="currentStep" :locations="locations" :importProfiles="importProfiles" :channels="channels" :categories="categories" :selectedUsers="selectedUsers" v-if="sessionType == 'photodesk'" @headerInterface="passEmit" />
        <CopydeskSteps :currentStep="currentStep" :channels="channels" :languages="languages" v-if="sessionType == 'copydesk'" />
        <ProjectdeskSteps :currentStep="currentStep" :channels="channels" :languages="languages" v-if="sessionType == 'projectdesk'" />

        <div class="form-buttons-w text-right">
          <button class="btn btn-primary" @click.prevent="previousStep" v-if="currentStep.index > 1">Previous</button>

          <button class="btn btn-primary" @click.prevent="nextStep" v-if="currentStep.index < filteredSteps.length">Continue</button>
          <button class="btn btn-primary" type="submit" v-else-if="currentStep.index == filteredSteps.length">Submit</button>
          <button class="btn btn-primary" v-else></button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import PhotodeskSteps from './Steps/PhotodeskSteps'
import CopydeskSteps from './Steps/CopydeskSteps'
import ProjectdeskSteps from './Steps/ProjectdeskSteps'
import FormMixin from '@/mixins/forms.js'

export default {
  mixins: [FormMixin],
  props: ['session-type', 'channels', 'categories', 'languages', 'selectedUsers', 'importProfiles', 'locations'],
  components: { PhotodeskSteps, CopydeskSteps, ProjectdeskSteps },
  data () {
    return {
      steps: [
        { name: 'Session', key: 'photodesk-session', group: 'photodesk' },
        {
          name: 'Misc',
          key: 'photodesk-misc',
          group: 'photodesk'
        },
        {
          name: 'Contributors',
          key: 'photodesk-contributors',
          group: 'photodesk'
        },
        {
          name: 'Session',
          key: 'copydesk-session',
          group: 'copydesk'
        },
        {
          name: 'Contributors',
          key: 'copydesk-contributors',
          group: 'copydesk'
        },
        {
          name: 'Project',
          key: 'projectdesk-project',
          group: 'projectdesk'
        },
        {
          name: 'Contributors',
          key: 'projectdesk-contributors',
          group: 'projectdesk'
        },
        {
          name: 'Products',
          key: 'projectdesk-products',
          group: 'projectdesk'
        }
        // { 'name': 'Notes', 'key': 'photodesk-notes', 'group': 'photodesk' }
      ],
      filteredSteps: [],
      currentStep: {
        key: '',
        index: 0
      }
    }
  },
  mounted () {
    this.initializeSteps()
  },
  methods: {
    initializeSteps () {
      var self = this
      var index = 1
      const filter = self.steps
        .filter(step => {
          if (step.group != self.sessionType) {
            return false
          }
          return true
        })
        .map(step => {
          step.index = index
          index++
          return step
        })
      self.filteredSteps = filter

      self.currentStep.key = self.filteredSteps[0].key
      self.currentStep.index = 1
      self.$store.dispatch('updateLoading', 'false')
    },
    previousStep () {
      var self = this
      let step = self.filteredSteps.find(
        filter => parseInt(filter.index) === this.currentStep.index - 1
      )

      this.currentStep.index--
      this.currentStep.key = step.key
    },
    nextStep () {
      var self = this

      let step = self.filteredSteps.find(
        filter => parseInt(filter.index) === this.currentStep.index + 1
      )
      this.currentStep.index++
      this.currentStep.key = step.key
    },
    customStep (key) {
      var self = this

      let step = self.filteredSteps.find(filter => filter.key === key)
      this.currentStep.index = step.index
      this.currentStep.key = step.key
    },
    submitForm () {
      if (this.sessionType == 'photodesk') {
        this.submitPhotodeskForm()
      }
      if (this.sessionType == 'copydesk') {
        this.submitCopydeskForm()
      }
      if (this.sessionType == 'projectdesk') {
        this.submitProjectdeskForm()
      }
    },
    passEmit (data) {
      this.$emit('headerInterface', data)
    }
  }
}
</script>
